import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { SaveRecordAction } from '@aibees/elephant/hooks/types';
import { SearchType } from '@aibees/elephant/types';

const keys = Object.keys(SaveRecordAction).filter(
  (x) => x !== SaveRecordAction.BASIC_SAVE
) as Array<keyof typeof SaveRecordAction>;

export function getSaveRecordsActionsFunction(
  data: {
    [key in SaveRecordAction]?: boolean;
  },
  type?: SearchType,
  modality?: SearchModality
) {
  return () => getSaveRecordsActions(data, type, modality);
}

export function getSaveRecordsActions(
  data: {
    [key in SaveRecordAction]?: boolean;
  },
  type?: SearchType,
  modality?: SearchModality
) {
  if (!type || type === SearchType.Company) return undefined;

  modality = modality ?? SearchModality.TOTAL;

  let response: SaveRecordAction[] = [];

  keys.forEach((key) => {
    if (data[key]) {
      response.push(SaveRecordAction[key]);
    }
  });

  if (modality === SearchModality.SAVED)
    response = response.filter(
      (x) => x !== SaveRecordAction.CONTACT_REVEAL_EMAIL
    );
  if (
    (modality === SearchModality.UNSAVED ||
      modality === SearchModality.TOTAL) &&
    data[SaveRecordAction.CONTACT_ENRICH_EMAIL]
  ) {
    response = response.filter(
      (x) => x !== SaveRecordAction.CONTACT_ENRICH_EMAIL
    );
    response.push(SaveRecordAction.CONTACT_REVEAL_EMAIL);
  }

  if (modality === SearchModality.UNSAVED) {
    response = response.filter(
      (x) => x !== SaveRecordAction.CONTACT_REVERIFY_EMAIL
    );
  }
  if (data[SaveRecordAction.AI_POWERED_ACCOUNT]) {
    response = response.filter(
      (x) => x !== SaveRecordAction.AI_POWERED_ACCOUNT
    );
  }
  if (data[SaveRecordAction.AI_POWERED_CONTACT]) {
    response = response.filter(
      (x) => x !== SaveRecordAction.AI_POWERED_CONTACT
    );
  }

  return response.length > 0 ? response : undefined;
}
